import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "panel",
    "date",
    "status",
    "scoreRow",
    "score",
    "consistencyRow",
    "consistency",
    "movementRow",
    "movement"
  ]

  connect() {
    this.activeTile = null
  }

  show(event) {
    this.activeTile = event.currentTarget
    this.render(event.params)
    this.panelTarget.classList.remove("hidden")
    this.panelTarget.classList.add("invisible")
    this.position(event.currentTarget)
    this.panelTarget.classList.remove("invisible")
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.activeTile === event.currentTarget && !this.panelTarget.classList.contains("hidden")) {
      this.hide()
    } else {
      this.show(event)
    }
  }

  hide(event) {
    if (event?.type === "mouseleave" && this.activeTile !== event.currentTarget) return
    if (event?.type === "blur" && this.activeTile !== event.currentTarget) return

    this.panelTarget.classList.add("hidden")
    this.panelTarget.classList.remove("invisible")
    this.activeTile = null
  }

  hideFromOutside(event) {
    if (this.panelTarget.classList.contains("hidden")) return
    if (event.target.closest("[data-track-record-tooltip-target~='tile']")) return

    this.hide()
  }

  render(params) {
    const evaluated = params.evaluated === true || params.evaluated === "true"

    this.dateTarget.textContent = params.date
    this.statusTarget.textContent = params.status || "No evaluation"

    this.setRow(this.scoreRowTarget, this.scoreTarget, params.score, evaluated)
    this.setRow(this.consistencyRowTarget, this.consistencyTarget, params.consistency, evaluated)
    this.setRow(this.movementRowTarget, this.movementTarget, params.movement, evaluated)
  }

  setRow(row, target, value, evaluated) {
    if (evaluated && value) {
      target.textContent = value
      row.classList.remove("hidden")
    } else {
      target.textContent = ""
      row.classList.add("hidden")
    }
  }

  position(tile) {
    const tileRect = tile.getBoundingClientRect()
    const hostRect = this.element.getBoundingClientRect()
    const panelRect = this.panelTarget.getBoundingClientRect()
    const margin = 8

    let left = tileRect.left - hostRect.left + (tileRect.width / 2) - (panelRect.width / 2)
    left = Math.max(margin, Math.min(left, hostRect.width - panelRect.width - margin))

    let top = tileRect.top - hostRect.top - panelRect.height - 10
    if (top < margin) {
      top = tileRect.bottom - hostRect.top + 10
    }

    this.panelTarget.style.left = `${left}px`
    this.panelTarget.style.top = `${top}px`
  }
}
